import { render, staticRenderFns } from "./InfoturesType.vue?vue&type=template&id=687d7a55&scoped=true&"
import script from "./InfoturesType.vue?vue&type=script&lang=js&"
export * from "./InfoturesType.vue?vue&type=script&lang=js&"
import style0 from "./InfoturesType.vue?vue&type=style&index=0&id=687d7a55&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d7a55",
  null
  
)

export default component.exports